














































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class AddPatientDialog extends Vue {
  @Prop()
  private projectId: any;
  @Prop()
  private visible: any;
  @Prop()
  private groups: any;
  @Prop()
  private hospitals: any;
  private patient: any = {};
  private visibleChange() {
    this.$emit("update:visible", this.visible);
  }
  private get ifVisible() {
    return this.visible ? this.visible : false;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  /**
   * @description 确定添加患者并进入采集页面
   */
  private addPatient() {
    if (!this.patient["姓名"]) {
      this.$message.warning("姓名必须填写");
      return;
    }
    if (!this.patient["性别"]) {
      this.$message.warning("性别必须选择");
      return;
    }
    if (!this.patient["出生日期"]) {
      this.$message.warning("出生日期必须填写");
      return;
    }
    const birthdayRep: RegExp = /\d{4}-[0-1]\d-\d{2}/gi;
    if (!birthdayRep.test(this.patient["出生日期"])) {
      this.$message.warning("出生日期格式不对，请重新输入");
      return;
    }
    if (!this.patient["认证方式"]) {
      this.$message.warning("认证方式必须选择");
      return;
    }
    if (!this.patient["身份证号"]) {
      this.$message.warning("认证号码必须填写");
      return;
    }
    this.patient.project_id = this.projectId;
    const params: any = this.patient;
    axios.post("api/project/patient", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("加入成功");
        this.$emit("finish", data.data);
      });
    });
  }
}
